import angular from 'angular';

/**
 * Controla la tabla de inspecciones.
 */
EntidadEnvioDetallesCtrl.$inject = ['$log', 'EnvioEntidad', 'dialogService'];
export default function EntidadEnvioDetallesCtrl($log, EnvioEntidad, dialogService) {
    var TAG = 'EntidadEnvioDetallesCtrl: ';
    var vm = this, id = null, tipo = null;
    vm.url = Sigo.var.path;
    vm.puedeEditar = Sigo.user.puedeEditarEntEnv;

    var templateDialogEdit = require('./addEditEntidadEnvioDialog.html');

    if (!angular.isUndefined(vm.incidenciaId) && angular.isNumber(vm.incidenciaId)) {
        vm.enTareas = false;
        id = vm.incidenciaId;
        tipo = 'incidencia';
    } else {
        vm.enTareas = true;
        id = vm.tareaId;
        tipo = 'tarea';
    }

    cargarEntidadesEnvio();

    vm.actualizar = function () {
        cargarEntidadesEnvio();
    };

    function cargarEntidadesEnvio() {
        vm.cargandoEntidadEnvio = true;

        if (tipo == 'incidencia')
            $log.debug(TAG + 'Cargando entidades envio de la incidencia ' + id + '...');
        else
            $log.debug(TAG + 'Cargando entidades envio de la tarea ' + id + '...');

        EnvioEntidad.query({
            tipo: tipo,
            id: id
        }, function (data) {
            switch (data.tipo) {
                case 'incidencia':
                    actualizaFilaVIncidencia(data.datosGrid, false);
                    break;
                case 'tarea':
                    actualizaFilaVTarea(data.datosGrid, false);
            }

            vm.entidadesEnvio = data.envios;
            if (typeof data.entidad !== 'undefined') vm.entidad = data.entidad;
            vm.cargandoEntidadEnvio = false;

            $log.debug('entidades envio cargadds!');
        }, function (err) {
            //TODO: Comprobar errores
            vm.cargandoEntidadEnvio = false;
        });
    }

    vm.anyadirEntidadEnvio = function () {
        $log.debug('Añadiendo un envio para la tarea ' + id + ' ...');
        var titulo = ucfirst(Lang.choice('nombres.anyadir', 1)) + ' ' + Lang.choice('nombres.envio', 1);

        var botones = {
            botonOk: titulo,
            botonCancel: ucfirst(Lang.get('nombres.cancelar')),
            validate: function (model) {
                if (!issetAndNotEmpty(model.mensaje)) {
                    Sigo.UI.Toast.error('Error', Lang.get('mensajes.error_ent_env_no_msg'));
                    return false;
                }
                return true
            }
        };

        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 400
        };

        dialogService.open("dialogAddEditarEntidadEnvio", templateDialogEdit, {
            tarea_id: id,
            entidad: vm.entidad
        }, options, botones)
            .then(function (result) {
                EnvioEntidad.save(result, function (data) {
                    $log.debug('envioEntidad añadida!');
                    // $log.debug(data);
                    // actualizaFilaVTarea(data.tarea);
                    cargarEntidadesEnvio();
                });
            });
    };

    vm.editarEntidadEnvio = function (entidadEnvio) {
        $log.debug('Añadiendo un envio de la tarea ' + id + ' ...');
        var titulo = ucfirst(Lang.choice('nombres.editar', 1)) + ' ' + Lang.choice('nombres.envio', 1);

        var botones = {
            botonOk: titulo,
            botonCancel: ucfirst(Lang.get('nombres.cancelar'))
        };

        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 400
        };

        var entidadEnvioCopia = angular.copy(entidadEnvio);
        entidadEnvioCopia.entidad = vm.entidad;

        dialogService.open("dialogAddEditarEntidadEnvio", templateDialogEdit, entidadEnvioCopia, options, botones)
            .then(function (result) {
                EnvioEntidad.update({envioEntidadId: entidadEnvio.id}, result, function (data) {
                    $log.debug('envioEntidad añadida!');
                    // entidadEnvio = result
                    // actualizaFilaVTarea(data.tarea);
                    cargarEntidadesEnvio();
                });
            });
    };

    vm.activarODesactivarEntidadEnvio = function (entidadEnvio) {
        $log.debug('Editando el envio con id ' + entidadEnvio.id);

        var cambioValor = !(parseInt(entidadEnvio.activo) == 1);
        EnvioEntidad.update({envioEntidadId: entidadEnvio.id}, {'activo': cambioValor}, function () {
            $log.debug('Envio editado editada!');
            entidadEnvio.activo = cambioValor ? 1 : 0;
        });
    };

    vm.isNumber = function (variable) {
        return angular.isDefined(variable) && angular.isNumber(variable);
    };
}